import { apiCreate, apiGetList } from './ApiBaseActions';
export const API_GET_NEWS = 'API_GET_NEWS';
export const API_GET_NEWS_SUCCESS = 'API_GET_NEWS_SUCCESS';
export const API_GET_NEWS_MORE = 'API_GET_NEWS_MORE';
export const API_GET_NEWS_MORE_SUCCESS = 'API_GET_NEWS_MORE_SUCCESS';
export const API_CREATE_NEWS_READ = 'API_CREATE_READ';
export const apiGetNews = (meta) => apiGetList(API_GET_NEWS, '/news', {}, meta || {});
export const apiGetNewsMore = (list, meta) => apiGetList(API_GET_NEWS_MORE, `/news?less_than=${list[list.length - 1].id}`, {}, meta || {});
export const apiReadNews = (meta) => apiCreate(API_CREATE_NEWS_READ, '/news/read', {}, meta || {});
